import buttonStyle from "./customButtons.module.css";

export type VariantType = "primary" | "secondary" | "tertiary";
export type ColorType = "blue" | "green" | "red";
export type TextColorType = "dark" | "light";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant: VariantType;
  color?: ColorType;
  textcolor?: TextColorType;
  disabled?: boolean;

  morepadding?: boolean;
}
function Button(props: Readonly<ButtonProps>) {
  const { variant, color = "blue", textcolor = "dark", morepadding, ...rest } = props;

  let chosenClass = buttonStyle.button;

  if (variant === "primary") chosenClass += " " + buttonStyle.primary;
  else if (variant === "secondary") chosenClass += " " + buttonStyle.secondary;
  else if (variant === "tertiary") chosenClass += " " + buttonStyle.tertiary;

  if (color === "blue") {
    if (textcolor === "dark") chosenClass += " " + buttonStyle.blueButton;
    else if(variant === "primary") chosenClass += " " + buttonStyle.darkBlueButton;
    else chosenClass += " " + buttonStyle.middleBlueButton;
  } else if (color === "green") chosenClass += " " + buttonStyle.greenButton;
  else if (color === "red") chosenClass += " " + buttonStyle.redButton;

  if (textcolor === "dark") chosenClass += " " + buttonStyle.darkText;
  else if (textcolor === "light") chosenClass += " " + buttonStyle.lightText;

  if(morepadding) chosenClass += " " + buttonStyle.morePadding;

  return <button className={chosenClass} {...rest} />;
}
export default Button;
